<template>
    <tr>
        <template v-if="option.remove">
            <td
                colspan="7"
                class="removed-option-cell"
            >
                ------ verwijderde
                <span v-if="!option.datafieldoptionId">nieuwe</span>
                optie
                <span v-if="option.datafieldoptionId">
                    #{{ option.datafieldoptionId }}
                </span>
                (
                <a @click="option.remove = false">ongedaan maken</a>
                ) ------
            </td>
        </template>
        <template v-else>
            <td v-if="option.datafieldoptionId">
                {{ option.datafieldoptionId }}
            </td>
            <td v-else>&nbsp;</td>
            <td>
                <text-input
                    class="td_codeId"
                    max="999999"
                    min="0"
                    type="number"
                    :readonly="option.datafieldoptionId"
                    v-model="option.codeId"
                />
                <div
                    v-if="getErrorFromValidator($v.option.codeId)"
                    class="error"
                >
                    {{ getErrorFromValidator($v.option.codeId) }}
                </div>
            </td>
            <td>
                <text-input
                    class="td_cncCodeId"
                    max="999999"
                    min="0"
                    type="number"
                    v-model="option.cncCodeId"
                />
                <div
                    v-if="getErrorFromValidator($v.option.cncCodeId)"
                    class="error"
                >
                    {{ getErrorFromValidator($v.option.cncCodeId) }}
                </div>
            </td>
            <td>
                <translations-edit
                    :language-value-updated="languageValueUpdated"
                    :translation-data="option.translations.dataoption"
                ></translations-edit>
            </td>
            <td>
                <ui5-input
                    class="td_order"
                    type="Number"
                    min="0"
                    :value="option.order"
                    @input="option.order = $event.target.value"
                />
                <div
                    v-if="getErrorFromValidator($v.option.order)"
                    class="error"
                >
                    {{ getErrorFromValidator($v.option.order) }}
                </div>
            </td>
            <td>
                <div class="td_image">
                    <img
                        v-if="option.image && option.image.url"
                        :src="option.image.url"
                        @error="$event.target.src = 'images/placeholder.png'"
                    />
                    <ui5-file-uploader
                        ref="imageUploader"
                        id="image"
                        @change="changeImage"
                        hide-input
                    >
                        <ui5-button>Nieuwe afbeelding uploaden</ui5-button>
                    </ui5-file-uploader>
                    <ui5-button
                        v-if="option.image && option.image.url"
                        @click="removeImage"
                    >
                        Afbeelding verwijderen
                    </ui5-button>
                </div>
            </td>
            <td>
                <text-input
                    class="td_paintAreaValue"
                    max="999999"
                    min="0"
                    step="any"
                    type="number"
                    v-model="option.paintAreaValue"
                />
                <div
                    v-if="
                        getErrorFromValidator($v.option.paintAreaValue).length
                    "
                    class="error"
                >
                    {{ getErrorFromValidator($v.option.paintAreaValue) }}
                </div>
            </td>
            <td>
                <ui5-checkbox
                    class="td_inUse"
                    :checked="option.inUse"
                    @change="option.inUse = $event.target.checked"
                />
                <div
                    v-if="getErrorFromValidator($v.option.inUse)"
                    class="error"
                >
                    {{ getErrorFromValidator($v.option.inUse) }}
                </div>
            </td>
            <td>&nbsp;</td>
        </template>
    </tr>
</template>

<script>
import ErrorHelper from '../../helpers/ErrorHelper';
import {
    numeric,
    required,
    maxLength,
    minValue,
} from 'vuelidate/lib/validators';
import TranslationsEdit from './../TranslationsEdit';
import TextInput from '../TextInput.vue';

const DATATYPE_OPTIONS = 4;
export default {
    props: {
        datafieldType: {
            required: true,
        },
        option: {
            required: true,
        },
        languages: {
            required: true,
        },
        defaultLanguage: {
            required: true,
        },
    },
    computed: {
        isOptions() {
            return this.datafieldType == DATATYPE_OPTIONS;
        },
    },
    methods: {
        getErrorFromValidator: ErrorHelper.getErrorFromValidator,
        languageValueUpdated(language, value) {
            if (language == this.defaultLanguage) {
                this.option.dataoption = value;
            }
        },
        changeImage(event) {
            const file = event.target.files[0];

            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const existingImage = this.option.image;
                    this.$set(this.option, 'image', {
                        image_path_s3: existingImage
                            ? existingImage.image_path_s3 || null
                            : null,
                        url: e.target.result,
                        file: file,
                        added: true,
                        removed:
                            existingImage && existingImage.image_path_s3
                                ? true
                                : false,
                    });
                };
                reader.readAsDataURL(file);
            }
        },
        removeImage() {
            const existingImage = this.option.image;
            this.$set(this.option, 'image', {
                image_path_s3: existingImage
                    ? existingImage.image_path_s3 || null
                    : null,
                url: '',
                file: null,
                added: false,
                removed: true,
            });
            this.$refs.imageUploader.value = '';
        },
    },
    validations() {
        const labelValidations = {};
        this.languages.forEach((x) => {
            labelValidations[x] = {
                maxLength: maxLength(65535),
            };
        });

        return {
            option: {
                codeId: {
                    //Sleutel
                    numeric: numeric,
                    between: required,
                },
                cncCodeId: {
                    required: required,
                    numeric: numeric,
                },
                translations: {
                    dataoption: { ...labelValidations },
                },
                order: {
                    min: minValue(0),
                    numeric: numeric,
                },
                paintAreaValue: {
                    numeric: numeric,
                },
                inUse: {
                    required: required,
                },
            },
        };
    },
    components: {
        'translations-edit': TranslationsEdit,
        'text-input': TextInput,
    },
};
</script>
